export function parseError(err: any, defaultMessage?: string): string {
  if (!err) {
    return 'Unknown error';
  }

  if (!err.message) {
    return `${err}`;
  }

  try {
    const parsed = JSON.parse(err.message);
    let message: string = parsed.message;
    if (message) {
      const { errors } = parsed;
      if (Array.isArray(errors)) {
        message = message + '\n' + errors.map((e: any) => String(e)).join('\n');
      }
      return message;
    }
  } catch {
    // ignore
  }
  return defaultMessage || `${err.message}`;
}
